export enum DocumentType {
    THERAPIST_CONSENT = 'THERAPIST_CONSENT',
    PROFILE_PIC ='PROFILE_PIC',
    OFFICE_PIC = 'OFFICE_PIC'
  }